export default "__VITE_ASSET__CPa1lO3n__"